import { GetAllEventRisksReq, GetAllEventRisksRes, UpdateEventRiskReq, UpdateEventRiskRes } from '../interfaces/eventRisk.interface';
import {API} from './api'



export const getAllEventRiskService = async (data: GetAllEventRisksReq): Promise<GetAllEventRisksRes>=>{
    try {
        const res = await API.get('/v1/event-risk');
        return res.data;
    } catch (error) {
        throw error
    }
}


export const updateEventRiskService = async (data: UpdateEventRiskReq): Promise<UpdateEventRiskRes>=>{
    try {
        const res = await API.put('/v1/event-risk', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

